import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export const BREAK_POINT = Object.freeze({
  MD: 768,
  LG: 1200,
  XL: 1400,
});

export const SCREEN = Object.freeze({
  MOBILE: `(max-width: ${BREAK_POINT.MD - 1}px)`,
  TABLET: `(min-width: ${BREAK_POINT.MD}px)`,
  MOBILE_TABLET: `(max-width: ${BREAK_POINT.LG - 1}px)`,
  SMALL_DESKTOP: `(min-width: ${BREAK_POINT.LG}px) and (max-width: ${BREAK_POINT.XL - 1}px)`,
  LARGE_DESKTOP: `(min-width: ${BREAK_POINT.XL}px)`,
  DESKTOP: `(min-width: ${BREAK_POINT.LG}px)`,
});

const CustomScreen = ({ screen, children }) => {
  const m = window.matchMedia(screen);
  const [matches, setMatches] = useState(m.matches);
  useEffect(() => {
    const listenerArgs = [
      'resize',
      () => {
        const doesMatch = window.matchMedia(screen).matches;
        if (matches !== doesMatch) setMatches(doesMatch);
      },
    ];
    window.addEventListener(...listenerArgs);
    return () => window.removeEventListener(...listenerArgs);
  });
  return matches ? children : null;
};

CustomScreen.propTypes = {
  screen: PropTypes.string.isRequired,
  children: PropTypes.node,
};

CustomScreen.defaultProps = {
  children: null,
};

export default CustomScreen;
